<template>
  <div class="bg-blue-900 text-white py-12">
    <div class="container mx-auto">
      <div class="flex flex-col md:flex-row items-start justify-between mx-6">
        <div class="order-last md:order-first">
          <div class="font-bold">
            School District of Philadelphia Central Office
          </div>
          <div>
            440 N. Broad Street
            <br />Philadelphia, PA 19130 <br />p: 215-400-4000
          </div>
        </div>
        <div v-if="haslinks">Subpage Links</div>
        <div class="order-first md:order-last mb-4 md:mb-0">
          <a href="https://www.philasd.org" target="_blank">
            <img
              class="w-56"
              alt="The School District of Philadelphia"
              src="~/assets/images/logo-white.png"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    haslinks: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
